(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalOrderContactDeleteController',AppraisalOrderContactDeleteController);

    AppraisalOrderContactDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppraisalOrderContact'];

    function AppraisalOrderContactDeleteController($uibModalInstance, entity, AppraisalOrderContact) {
        var vm = this;

        vm.appraisalOrderContact = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppraisalOrderContact.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
